<template>
  <div class="reg">
    <!-- 登录注册 -->
    <el-dialog
      title="设置密码"
      custom-class="login-form"
      :visible.sync="resetPwdVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-container>
        <el-form
          :model="user"
          status-icon
          :rules="rules"
          ref="form"
          style="min-height: 250px"
        >
          <el-form-item prop="newPassword">
            <el-input
              type="password"
              v-model="user.newPassword"
              placeholder="请输入密码"
              auto-complete="new-password"
            ></el-input>
          </el-form-item>
          <el-form-item prop="verPassword">
            <el-input
              type="password"
              v-model="user.verPassword"
              placeholder="再次输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="activationOrder">
            <el-row>
              <el-col :span="16">
                <el-input
                  v-model="user.activationOrder"
                  auto-complete="autoComplete"
                  placeholder="请输入短信验证码"
                  style="width: 100%"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <div class="login-code">
                  <el-button
                    :disabled="isDisabledPRegister"
                    @click="registerCaptcha"
                    style="padding: 0 !important"
                  >
                    <span>{{ buttonNamePRegister }}</span>
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button
              type="success"
              style="background: #39c1c2; width: 100%"
              @click="resetPwd()"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['resetPwdVisible', 'childForm'],
  data () {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.user.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      user: {
        userId: '',
        newPassword: null,
        verPassword: null,
        remark: '',
        phonenumber: ''
      },
      isDisabled: false,
      isDisabledPRegister: false,
      buttonNamePRegister: '发送短信',
      timePRegister: 60,
      rules: {
        verPassword: [
          { validator: validatePass, trigger: 'blur' },
          {
            pattern:
              /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
            message: '密码长度为8-30位，且包含数字、符号、字母'
          }
        ],
        newPassword: [
          { required: true, trigger: 'blur', message: '新密码不能为空' },
          {
            pattern:
              /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/,
            message: '密码长度为8-30位，且包含数字、符号、字母'
          }
        ],
        activationOrder: [
          { required: true, trigger: 'change', message: '验证码不能为空' }
        ]
        /*   verPassword: [{ validator: validatePass, trigger: "blur" }],
        newPassword: [
          { required: true, trigger: "blur", message: "密码不能为空" }
        ] */
      }
    }
  },
  mounted () {
    this.user.userId = this.$store.state.user.userId
    this.user.phonenumber = this.childForm.phonenumber
  },

  watch: {
    childForm (newV, oldV) {
      this.user.phonenumber = this.childForm.phonenumber
    },
    deep: true // 深度监听父组件传过来对象变化
  },
  methods: {
    resetPwd () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          // 验证邮箱或短信验证码
          var api = this.systemURL + '/actuator/before/setPwdByUserId'
          this.axios.post(api, this.user).then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.msg)
              this.handleClose()
              var url =
                this.systemURL +
                '/actuator/before/getUserById?userId=' +
                this.$store.state.user.userId
              this.axios.get(url, {}).then((res) => {
                if (res.data.code == 200) {
                  this.$store.state.user.password = res.data.user.password
                  console.log(this.$store.state.user)
                  this.$emit('setPassword', res.data.user.password)
                } else {
                  this.$message.error(res.data.msg)
                }
              })
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose () {
      this.stepsActive = 0
      this.$parent.setPwdVisible = false
      this.isDisabled = false
      for (let key in this.user) {
        if (key != 'userId') this.user[key] = null
      }
    },
    registerCaptcha () {
      // 发送手机验证码 注册
      let phonenumber = this.childForm.phonenumber
      let mailReg = /^1[3456789]\d{9}$/
      if (!mailReg.test(phonenumber)) {
        this.$message.warning('请确认手机号是否正确')
        return
      }
      var api = this.systemURL + '/actuator/before/getCaptcha'
      var params = {
        phonenumber: phonenumber,
        siteId: this.siteId
      }
      this.axios.post(api, params).then((res) => {
        if (res.data.code == 500) {
          this.$message.error(res.data.msg)
          return
        }
        this.$message.success('已发送手机验证码，请查收')
        this.isDisabledPRegister = true
        this.user.remark = res.data.uuid
        let interval = window.setInterval(() => {
          this.buttonNamePRegister = '(' + this.timePRegister + '秒)后重发'
          --this.timePRegister
          if (this.timePRegister < 0) {
            this.buttonNamePRegister = '重新发送'
            this.timePRegister = 60
            this.isDisabledPRegister = false
            window.clearInterval(interval)
          }
        }, 1000)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid-content {
  height: 60px;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0px;
}
.register {
  color: #1ab2ff;
  cursor: pointer;
}
.register:hover {
  color: #2c2fd6;
}
</style>

<style >
.reg .el-form {
  width: 100%;
}

::v-deep .v-modal{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/my/components/setPwd.vue